module.exports = __webpack_public_path__ + "static/media/project.30235091.png";